import isAlphanumeric from 'validator/es/lib/isAlphanumeric'
import isEmail from 'validator/es/lib/isEmail'

export const required = {
  required: 'A value is required'
}

export const email = {
  validate: {
    email: (value?: string) => isEmail(value) || 'Invalid email'
  }
}

export const minimumCharacterLength = (length: number) => ({
  validate: {
    minimumCharacterLength: (value?: string) =>
      (value || '').length >= length || `Must be at least ${length} characters`
  }
})

export const containsUpperCaseLetter = {
  validate: {
    containsUpperCaseLetter: (value?: string) =>
      /[A-Z]/g.test(value) || 'Must contain 1 upper case letter'
  }
}

export const minimumAmountOfNumbers = (amount: number) => ({
  validate: {
    minimumAmountOfNumbers: (value?: string) =>
      value && (value.match(/[0-9]/g) || []).length >= amount
        ? undefined
        : `Must contain at least ${amount} ${amount === 1 ? 'number' : 'numbers'}`
  }
})

export const alphanumeric = {
  validate: {
    alphanumeric: (value?: string) =>
      isAlphanumeric(value || '') || 'Must not contain any special symbols'
  }
}

export const validatePassword = (password: string) => {
  const hasMinimumCharacters = !(
    typeof minimumCharacterLength(8).validate.minimumCharacterLength(password) === 'string'
  )
  const hasOneUppercaseLetter = !(
    typeof containsUpperCaseLetter.validate.containsUpperCaseLetter(password) === 'string'
  )
  const hasTwoNumbers = !(
    typeof minimumAmountOfNumbers(2).validate.minimumAmountOfNumbers(password) === 'string'
  )
  const isAlphanumeric = !(typeof alphanumeric.validate.alphanumeric(password) === 'string')

  return {
    hasMinimumCharacters,
    hasOneUppercaseLetter,
    hasTwoNumbers,
    isAlphanumeric
  }
}
